module.exports = __webpack_public_path__ + "img/biaodian.020a5473.svg";